export default function Tasks ({ projectId, title, description, duedate, priority, done }) {
	const taskId = Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, 0);

	return Object.freeze({
		get projectId() { return projectId; },
		get title() { return title; },
		set title(newTitle) { title = newTitle; },
		get description() { return description; },
		set description(newDescription) { description = newDescription; },
		get duedate() { return duedate; },
		set duedate(newDuedate) { duedate = newDuedate; },
		get priority() { return priority; },
		set priority(newPriority) { priority = newPriority; },
		get done() { return done; },
		set done(newDone) { done = newDone; },
		get taskId() { return taskId },
	});
}
